// import React from 'react'
// import { useSelector, useDispatch } from "react-redux";
// import OrganizationView from './views/organizationView';
// import './iamViewer.css'

// const IamViewer = (props) => {
//   const { user } = useSelector(state => state.appStore)

//   return (
//     <div className="iam-viewer-container">
//       <OrganizationView />
//     </div>
//   )
// }

// export default IamViewer

import React from 'react';
// import OrganizationView from './views/organizationView';
// import RoleViewer from '../RoleViewer/RoleViewer';

const IamViewer = ({ selectedKey }) => {
  const renderContent = () => {
    switch (selectedKey) {
      case '1':
        // return  <OrganizationView />;
      case '2':
        // return <RoleViewer />;
      case '3':
        // return <UsersComponent />;
      case '4':
        // return <PermissionsComponent />;
      default:
        // return <OrganizationsComponent />;
    }
  };

  return (
    <div className="iam-viewer-container">
      {renderContent()}
    </div>
  );
};

export default IamViewer;

const OrganizationsComponent = () => <div>Organizations Content</div>;
// const RolesComponent = () => <div>Roles Content</div>;
const UsersComponent = () => <div>Users Content</div>;
const PermissionsComponent = () => <div>Permissions Content</div>;
